export default "__VITE_ASSET__CATVwNrK__"